export interface DepartmentDropdownActionType {
  type: DepartmentDropdown;
  payload?: any;
}

export enum DepartmentDropdown {
  GET_DEPARTMENT_DROPDOWN_LIST = "GET_DEPARTMENT_DROPDOWN_LIST",
  SET_DEPARTMENT_DROPDOWN_LIST = "SET_DEPARTMENT_DROPDOWN_LIST",
  SET_DEPARTMENT_DROPDOWN_LOADING = "SET_DEPARTMENT_DROPDOWN_LOADING",
}
